var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secondary-menu-header"},[_c('i',{staticClass:"back",on:{"click":function($event){return _vm.goTo('/discover')}}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Settings")])])
}
var staticRenderFns = []

export { render, staticRenderFns }